import { useState, useEffect } from 'react';
import Balance from './Balance';
import Ops from './Ops';
import TransactionList from './TransactionList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPowerOff,
  faCalendarDays,
  faUserGroup,
  faCircleUser,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import { Form, redirect } from 'react-router-dom';
import UpdateDeleteForm from './UpdateDeleteForm';
import getMonth from './setMonth';
import { toast } from 'react-toastify';
import Help from './Help';
import NoData from './NoData';

export const logoutAction = async () => {
  localStorage.clear();
  toast.success('Ai iesit din aplicatie!');
  return redirect('/');
};

const Dashboard = () => {
  const [infoLogin, setInfoLogin] = useState(null);
  const showInfoLogin = members => {
    if (members) setInfoLogin(members);
  };

  const [infoMonth, setInfoMonth] = useState(null);
  const showInfoMonth = timeStamp => {
    const month = new Date(timeStamp).toLocaleString('ro-Ro', {
      month: 'long',
      year: 'numeric',
    });
    setInfoMonth(month);
  };

  const [infoCreatedBy, setInfoCreatedBy] = useState(null);
  const showInfoCreatedBy = selected => {
    const createdBy = selected === 'all' ? 'Toti membrii' : selected;
    setInfoCreatedBy(createdBy);
  };

  const [showHelp, setShowHelp] = useState(false);

  const [showUpdateDeleteForm, setShowUpdateDeleteForm] = useState(false);
  const toggleUpdateDeleteForm = () =>
    setShowUpdateDeleteForm(!showUpdateDeleteForm);

  const [transactionId, setTransactionId] = useState(null);
  const getTransactionId = id => setTransactionId(id);

  const [transactions, setTransactions] = useState(null);
  const fetchTransactions = async (trackerId, type, createdBy, month) => {
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/transactions/filters/${trackerId}/${type}/${createdBy}/${month}`
      );
      if (!res.ok)
        throw new Error(
          `Error fetching data: ${res.status} - ${res.statusText}`
        );
      const data = await res.json();
      setTransactions(data);
    } catch (error) {
      toast.error('Eroare date tranzactii!');
      console.log(error.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const { trackerId, members } = JSON.parse(
      localStorage.getItem('user')
    );
    showInfoLogin(members);
    showInfoMonth(getMonth());
    showInfoCreatedBy(members);
    fetchTransactions(trackerId, 'all', members, getMonth());
  }, []);

  return (
    <section>
      <div className='container1'>
        {showHelp && <Help />}
        {transactionId && showUpdateDeleteForm && (
          <UpdateDeleteForm
            toggle={toggleUpdateDeleteForm}
            transactionId={transactionId}
            fetchTransactions={fetchTransactions}
            showInfoMonth={showInfoMonth}
            showInfoCreatedBy={showInfoCreatedBy}
          />
        )}
        <div className='login-info'>
          {infoLogin && (
            <p>
              <FontAwesomeIcon
                icon={faCircleUser}
                size='lg'
                style={{ color: '#6c757d' }}
              />
              <span>Buna,</span>
              {infoLogin}
            </p>
          )}
          <div className='menu'>
            <FontAwesomeIcon
              icon={faCircleQuestion}
              fontSize={24}
              className='btn-help'
              title='Help'
              onClick={() => setShowHelp(!showHelp)}
            />
            <Form method='post' action='/logout'>
              <button className='btn-logout' title='Logout'>
                <FontAwesomeIcon icon={faPowerOff} fontSize={24} />
              </button>
            </Form>
          </div>
        </div>
        {transactions && <Balance transactions={transactions} />}
        <Ops
          fetchTransactions={fetchTransactions}
          showInfoMonth={showInfoMonth}
          showInfoCreatedBy={showInfoCreatedBy}
        />
        <div className='filters-info'>
          {infoMonth && (
            <p>
              <FontAwesomeIcon
                icon={faCalendarDays}
                style={{ color: '#6c757d' }}
              />
              <span>{infoMonth}</span>
            </p>
          )}
          {infoCreatedBy && (
            <p>
              <FontAwesomeIcon
                icon={faUserGroup}
                style={{ color: '#6c757d' }}
              />
              <span>{infoCreatedBy}</span>
            </p>
          )}
        </div>
      </div>
      <div className='container2'>
        {transactions && !transactions.length && <NoData />}
        {transactions && (
          <TransactionList
            transactions={transactions}
            toggle={toggleUpdateDeleteForm}
            getTransactionId={getTransactionId}
          />
        )}
      </div>
    </section>
  );
};

export default Dashboard;
